
<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="passwordSubmit">
                <card type="login">
                  <div
                    class="alert alert-dismissible fade show"
                    :class="alertType"
                    v-if="showAlert==true"
                  >
                    <button
                      type="button"
                      aria-hidden="true"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <i class="nc-icon nc-simple-remove"></i>
                    </button>

                    <div>
                      <span>{{alertMsg}}</span>
                    </div>
                  </div>
                  <h3 slot="header" class="header text-center">Enter New Password:</h3>

                  <fg-input
                    v-model="password"
                    addon-left-icon="nc-icon nc-key-25"
                    placeholder="Password"
                    type="password"
                  ></fg-input>
                  <fg-input
                    v-model="password_confirm"
                    addon-left-icon="nc-icon nc-key-25"
                    placeholder="Confirm Password"
                    type="password"
                  ></fg-input>

                  <br />

                  <!-- <p-checkbox>Subscribe to newsletter</p-checkbox> -->

                  <p-button
                    native-type="submit"
                    slot="footer"
                    type="info"
                    round
                    block
                    class="mb-3"
                  >Update Password</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg) "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "@/components/Dashboard/Views/Pages/Layout/AppNavbar";
import AppFooter from "@/components/Dashboard/Views/Pages/Layout/AppFooter";
export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  name: "password",
  data() {
    return {
      show0: false,
      show1: false,
      show2: false,
      password: "",
      password_confirm: "",
      alertMsg: null,
      alertType: "",
      displayAlert: false,
      showAlert: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters",
        matchPass: value => value === this.password || "Password must match"
      }
    };
  },
  created: function() {
    let confirmData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    if (typeof confirmData.token === "undefined") {
      this.$router.push("/");
    }
  },
  methods: {
    passwordSubmit: function(e) {
      try {
        let self = this;
        e.preventDefault();

        let confirmData = this.$route.query;

        if (this.password != this.password_confirm) {
          self.alertMsg = "Confirmed password does not match.";
          self.showAlert = true;
          self.alertType = "alert-danger";
        } else {
          firebase
            .auth()
            .confirmPasswordReset(confirmData.token, self.password)
            .then(resp => {
              // Password reset has been confirmed and new password updated.
              //console.log("SUCCESS");
              self.$router.push({
                path: "login",
                query: {
                  msg_show: true,
                  msg_type: "success",
                  msg: "Password updated successfully!"
                }
              });
            })
            .catch(err => {
              //console.log("THERE WAS AN ERROR: ", err);
              if (err.code == "auth/weak-password") {
                self.alertMsg =
                  "The password must be 6 characters long or more.";
              }
              if (err.code == "auth/wrong-password") {
                self.alertMsg =
                  "The password is invalid or the user does not have a password.";
              }
              if (self.alertMsg == null) {
                self.alertMsg =
                  "There was an error resetting your password. Please try again.";
              }
              self.showAlert = true;
              self.alertType = "alert-danger";
              // Error occurred during confirmation. The code might have
              // expired or the password is too weak. alert(e);
            });
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
        this.showAlert = true;
        this.alertType = "alert-danger";
        this.alertMsg =
          "There was an error resetting your password. Please try again.";
      }
    }
  }
};
</script>
<style scoped>
</style>